module.exports = __webpack_public_path__ + "static/media/driver-circle.5d8f5bca.svg";